"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var select_1 = require("../select");
var theme = require("./theme.scss");
var react_css_themr_1 = require("@vidazoo/react-css-themr");
var identifiers_1 = require("../identifiers");
function factory(items, selectedLabelFormatter) {
    return function (props) {
        var _a;
        return (React.createElement(react_css_themr_1.ThemeProvider, { theme: (_a = {}, _a[identifiers_1.SELECT] = theme, _a) },
            React.createElement(select_1.default, tslib_1.__assign({ items: items, maxItems: 5, placeholder: "Select Time Zone", itemLabelKey: "label", itemValueKey: "value" }, props, { value: props.timezone, defaultValue: props.defaultTimezone, selectedLabelFormatter: selectedLabelFormatter }))));
    };
}
exports.default = factory;
